import { autoserialize, autoserializeAs, inheritSerialization } from 'cerialize';
import { AbstractModel, DateUtil, isNullOrUndefined } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class Driver extends AbstractModel {
  @autoserialize
  emailAddress: string;

  @autoserialize
  firstName: string;

  @autoserialize
  middleName: string;

  @autoserialize
  lastName: string;

  @autoserialize
  hasMiddleName: boolean;

  @autoserialize
  phoneNumber: string;

  @autoserialize
  active: boolean;

  @autoserialize
  claraPersonIdentifier: number;

  @autoserialize
  taxIdType: string;

  @autoserialize
  hasBeenApproved: boolean;

  @autoserializeAs(Date)
  dateOfBirth: Date;

  @autoserialize
  randomDrugScreeningEligible: boolean;

  static OnSerialized(instance: Driver, json: any): void {
    super.OnSerialized(instance, json);

    if (!isNullOrUndefined(instance.dateOfBirth)) {
      json.dateOfBirth = DateUtil.serializeLocalDate(instance.dateOfBirth);
    }
  }

  static OnDeserialized(instance: Driver, json: any): void {
    super.OnDeserialized(instance, json);

    if (!isNullOrUndefined(json['dateOfBirth'])) {
      instance.dateOfBirth = DateUtil.deserializeLocalDate(json['dateOfBirth']);
    }
  }
}
